import { LockSimpleOpen } from "@phosphor-icons/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actions } from "astro:actions";
import type React from "react";
import { use } from "react";

import { useModal } from "~/components/Modal";
import { useLocale } from "~/hooks/locale";
import { useTheme } from "~/hooks/theme";
import type { Theme } from "~/theme";
import { trackEvent } from "~/utils/analytics";

import { PreGameIdContext } from "../../../PreGameIdContext";

export const UnlockTheme: React.FC<{
  isDisabled: boolean;
  themeKey: Theme;
  amount: number;
}> = ({ isDisabled, themeKey, amount }) => {
  const { t } = useLocale();
  const { closeModal } = useModal();
  const [, setTheme] = useTheme();

  const id = use(PreGameIdContext);
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: actions.me.purchase.orThrow,
    onSuccess: (data) => {
      closeModal();
      setTheme(themeKey);
      trackEvent("unlock_theme");
      queryClient.setQueryData<
        Awaited<ReturnType<typeof actions.me.getTransactions.orThrow>>
      >(["transactions", id], (prev) => prev && [...prev, data]);
    },
  });

  return (
    <button
      className="btn btn-secondary"
      disabled={isDisabled || isPending}
      onClick={() => {
        mutate({
          item: themeKey,
          amount,
        });
      }}
    >
      <LockSimpleOpen className="size-5" weight="bold" />
      {t("unlock_theme")}
    </button>
  );
};
